import {plural} from "@lingui/core/macro";
import * as React from "react";

import ReactOdometer from "#odometer-package/odometer.tsx";
import type {ProfileModelType} from "#shared-package/profile-model.ts";

import BadgeCounts from "./badge-counts.tsx";

type Props = {
    profile: ProfileModelType;
};

/**
 * Badge counts and energy points that appear on the top right side of the
 * dashboard.
 */
const UserPointsAndBadges = (
    props: Props,
): null | React.ReactElement<React.ComponentProps<"div">> => {
    const {profile} = props;

    if (!profile) {
        return null;
    }

    const points = profile.get("points");
    const url = profile.get("profileRoot") + "badges";

    return (
        <div className="user-summary-view__points-and-badges">
            <span
                className="energy-points-container"
                title={plural(points, {
                    one: "# energy point",
                    other: "# energy points",
                })}
            >
                <span className="energy-points-badge fixed-width">
                    {profile.isSal() ? (
                        <span>&infin;</span>
                    ) : (
                        <ReactOdometer value={points} theme="minimal" />
                    )}
                </span>
            </span>

            {/*
                HACK (josh): We're using floats to keep this stuff positioned,
                and for some reason setting float: none tends to cause it to
                clip its children's padding. Super weird fix, but addign an
                empty span fixes it.
            */}
            <span />

            <div className="user-summary-view__points-and-badges__badges">
                <BadgeCounts counts={profile.get("badgeCounts")} url={url} />
            </div>
        </div>
    );
};

export default UserPointsAndBadges;
